var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#ECEEF0",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8828 18V24.4444C35.8828 24.8717 36.0514 25.2815 36.3514 25.5837C36.6515 25.8858 37.0585 26.0556 37.4828 26.0556H43.8828M35.8828 18H29.4828C28.6341 18 27.8202 18.3395 27.2201 18.9438C26.62 19.5481 26.2828 20.3676 26.2828 21.2222V37.3333C26.2828 38.1879 26.62 39.0075 27.2201 39.6118C27.8202 40.2161 28.6341 40.5556 29.4828 40.5556H40.6828C41.5315 40.5556 42.3454 40.2161 42.9456 39.6118C43.5457 39.0075 43.8828 38.1879 43.8828 37.3333V26.0556M35.8828 18L43.8828 26.0556M37.4828 40.5556V43.7778C37.4828 44.6324 37.1457 45.4519 36.5456 46.0562C35.9454 46.6605 35.1315 47 34.2828 47H23.0828C22.2341 47 21.4202 46.6605 20.8201 46.0562C20.22 45.4519 19.8828 44.6324 19.8828 43.7778V27.6667C19.8828 26.8121 20.22 25.9925 20.8201 25.3882C21.4202 24.7839 22.2341 24.4444 23.0828 24.4444H26.2828",
    stroke: "#8E97A3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.b42cf722817f9b920495974efee07774.svg";
export { ForwardRef as ReactComponent };